import axios from "axios";
import { UserResponse } from "../types";
import envConfig from "../../environment";
import { socket } from "@utils/socket/socket";

// DTOs
export type LoginCredentialsDTO = {
  email: string;
  password: string;
  userType: "lender" | "borrower";
};

export type ForgetPasswordDTO = {
  email: string;
  userType: "lender" | "borrower";
};
export type phoneVerificationDTO = {
  phoneNumber: string;
  userType: "lender" | "borrower";
  userId:string;
};

export type ResetPasswordDTO = {
  userType: "lender" | "borrower";
  email: string;
  otp: string;
  password: string;
  confirmPassword: string;
};
export type ChangePasswordDTO = {
  userType: "lender" | "borrower";
  email: string;
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export type VerifyOtpDTO = {
  email: string;
  otp: string;
  userType: "lender" | "borrower";
};

export type ResendOtpDTO = {
  email: string;
};

export type NewPasswordDTO = {
  email: string;
  oldPassword: string;
  password: string;
  confirmPassword: string;
};

export type SignupCredentialsDTO = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  userType: string;
};

export type DocumentVerificationDTO = {
    userId: string;
    userType: "lender" | "borrower";
    file?: File | null;
};


// API Calls
export const loginUser = (data: LoginCredentialsDTO): Promise<UserResponse> => {
  return axios.post(`${envConfig.apiUrl}/auth/login`, data);
};

export const logout = () => {
  sessionStorage.clear();
  socket.disconnect();
};

export const signupUser = (
  data: SignupCredentialsDTO
): Promise<UserResponse> => {
  return axios.post(`${envConfig.apiUrl}/auth/signup`, data);
};

export const forgetPassword = (data: ForgetPasswordDTO): Promise<any> => {
  return axios.post(`${envConfig.apiUrl}/auth/forget-password`, {
    email: data.email,
    userType: data.userType, // ensure userType is passed
  });
};

export const phoneVerification = (data: phoneVerificationDTO): Promise<any> => {
  return axios.post(`${envConfig.apiUrl}/auth/verify-phone-otp`, {
    phoneNumber: data.phoneNumber,
    userType: data.userType, // ensure userType is passed
    userId:data.userId
  });
};

export const documentVerification = (data: DocumentVerificationDTO): Promise<any> => {
    const formData = new FormData();
    formData.append("userId", data.userId);
    formData.append("userType", data.userType);
    if (data.file) {
        formData.append("documents", data.file);
    }

    return axios.post(`${envConfig.apiUrl}/auth/document-verification`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

export const resetPassword = (data: ResetPasswordDTO): Promise<unknown> => {
  return axios.post(
    `${envConfig.apiUrl}/auth/reset-password?email=${data.email}`,
    {
      otp: data.otp,
      password: data.password,
      userType: data.userType,
      confirmPassword: data.confirmPassword,
    }
  );
};

export const changePassword = (data: ChangePasswordDTO): Promise<unknown> => {
  return axios.put(`${envConfig.apiUrl}/user/change-password`, {
    userType: data.userType,
    email: data.email,
    oldPassword: data.oldPassword,
    newPassword: data.newPassword,
    confirmPassword: data.confirmPassword,
  });
};
export const setNewPassword = (data: NewPasswordDTO): Promise<unknown> => {
  return axios.post(
    `${envConfig.apiUrl}/auth/new-password?email=${data.email}&oldPassword=${data.oldPassword}`,
    {
      password: data.password,
      confirmPassword: data.confirmPassword,
    }
  );
};

export const verifyEmailOtp = (data: VerifyOtpDTO): Promise<unknown> => {
  return axios.post(
    `${envConfig.apiUrl}/auth/verify-email-otp?email=${data.email}&roleType=${data.userType}`, // Added roleType in the query
    { otp: data.otp } // Send OTP in the request body
  );
};

export const resendOtp = (data: ResendOtpDTO): Promise<unknown> => {
  return axios.post(
    `${envConfig.apiUrl}/auth/resend-otp?email=${data.email}`,
    data
  );
};

export const getVerificationStatus = (userId: string): Promise<any> => {
  return axios.get(`${envConfig.apiUrl}/auth/verification-status/${userId}`);
};
